//  Вес - г, Объем - мл, Единица - шт, Размер - см,
export enum Units { weight, volume, unit, size, unknown }

// Новинка, Хит, Острое, Алкоголь, Вегетарианское, High protein, Безалкогольное, Свинина
export enum Labels { premiere, hit, spicy, vegan, protein, alcohol, nonalcohol, pork, unknown }

export enum TariffPlan { 'Free', 'Business', 'Premium' }

// Аллергены — 14 из Приложения II Регламента (ЕС) № 1169/2011, в его
// порядке; в Firestore — строки с теми же именами (как enum Allergens в приложении)
export enum Allergens {
  gluten,
  crustaceans,
  eggs,
  fish,
  peanuts,
  soy,
  milk,
  nuts,
  celery,
  mustard,
  sesame,
  sulphites,
  lupin,
  molluscs,
  unknown,
}

/** Строка из Firestore → аллерген; незнакомая (из новой версии приложения) — unknown */
export function getAllergenEnumValue(allergen: string): Allergens {
  const value = Allergens[allergen as keyof typeof Allergens];
  return value ?? Allergens.unknown;
}

/** Аллергены из нескольких списков — без повторов и unknown, в порядке Приложения II */
export function mergeAllergens(...lists: (readonly Allergens[] | null | undefined)[]): Allergens[] {
  const found = new Set(lists.flatMap((list) => list ?? []));
  found.delete(Allergens.unknown);
  return [...found].sort((a, b) => a - b);
}
